import { useState, useCallback, useEffect } from "react";
import Header from "../../Pages/Header";
import Sidebar from "../../Pages/Sidebar";
import { Typography , Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import settingsApi from "Services/Settings";

//redux
import { useDispatch } from "react-redux";
import { profiledetails } from "../../Redux/ProfileSettings/actions";

const useStyles = makeStyles((theme) => ({
  // layout: {
  //   background: "#EAEDEF",
  //   height: "calc(100vh - 70px)",
  //   overflowY: "auto",
  //   scrollbarWidth: "none"
  // },
  layout: {
    background: "#EAEDEF",
    scrollbarWidth: "none"
  },
  title: {
    display: "flex",
    gap: 12,
    justifyContent: "center",
    padding: "20px 0px",
  },
  // pages: {
  //   background: "#fff",
  //   borderRadius: 8,
  // },
  pages: {
    background: "#fff",
    borderRadius: 8,
    flexGrow: 1,
    overflow:"scroll",
    minHeight:"100vh",
    maxHeight:"100vh",
  },
  sidebarclose: {
    flex: 0,
    transition: "flex 0.3s ease-in-out",
  },
  sidebaropen: {
    flex: 2,
    transition: "flex 0.3s ease-in-out",
  },
  headbodyclose: {
    flex: 10,
  },
  headbodyopen: {
    flex: 12,
  },
  headstamps: {
    height: '100vh',
    margin: 0,
  },
}));

const HomeLayout = ({ children, icon, label, noPadding }) => {

  const dispatch = useDispatch();
  const [profileDetails, setProfileDetails] = useState([]);
  const classes = useStyles();

  const sidebarOpen = useSelector((state) => state.sidebar.isOpen);

  //console.log("Sidebar Open State in HomeLayout:", sidebarOpen);
  
    // Get Admin profile details
    const getAdminProfileDetails = useCallback(() => {
      const onSuccess = (res) => {
        if (res?.data?.status === true) {
          setProfileDetails(res?.data?.data);
         // console.log('res?.data?.data-->',res?.data?.data);
          dispatch(profiledetails(res?.data?.data));
        } else {
          setProfileDetails([]);
        }
      };
      const onFailure = (err) => {
        //console.log("get admin profile details api", err);
      };
      settingsApi.getProfileDetails({}).then(onSuccess, onFailure);
    }, []);

    useEffect(() => {
        getAdminProfileDetails();
      }, [getAdminProfileDetails]);
    

  return (
    <>
<Grid container className={classes.headstamps} >

{/*Sidebar*/}

<Grid 
    item 
    xs={sidebarOpen ? 4 : 2} 
    md={sidebarOpen ? 3 : 1} 
    lg={sidebarOpen ? 2 : 1} 
    xl={sidebarOpen ? 2 : 1}  className={ `${sidebarOpen ? classes.sidebaropen : classes.sidebarclose }` }
    style={{ display: 'flex', flexDirection: 'column'}}
    >

<Sidebar profileDetails={profileDetails}/>
</Grid>

{/*Header and body */}

<Grid 
    item 
    xs={sidebarOpen ? 8 : 10} 
    md={sidebarOpen ? 9 : 11} 
    lg={sidebarOpen ? 10 : 11} 
    xl={sidebarOpen ? 10 : 11}  className={`${sidebarOpen ?  classes.headbodyclose : classes.headbodyopen  }`}>
<Header profileDetails={profileDetails}/>

{/*body*/}

<section className={classes.layout}>
  
{icon &&  <section className={classes.title}>
    {icon && <section>{icon}</section>}
    <section>
      <Typography sx={{ fontSize: 18 }} variant="body1">
        {label}
      </Typography>
    </section>
  </section>
}

  <div
    className={classes.pages}
    style={
      noPadding
        ? { paddingBlock: 0, paddingInline: 0 }
        : { paddingBlock: 16, paddingInline: 16 }
    }
  >
    {" "}
    {children}
  </div>
</section>
</Grid>
 </Grid>   
    </>
  );
};

export default HomeLayout;
